import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

export default function* beginPartner() {
  yield effects.put.resolve(pushPath('/partner/new'))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/beginPartner.js